@if ((isLoading$ | async) === false) {
  <div>
    <div class="mb-8 flex justify-end">
      <aux-button
        classList="ml-2 mr-2"
        label="Refresh"
        variant="secondary"
        (clickEmit)="onRefresh()"
        [loading]="loading()"
        [disabled]="loading()"
        data-pendo-id="refresh-exchange-rates"
      />
      <aux-export-excel-button
        [clickFN]="onExport.bind(this)"
        [spinnerSize]="7"
        pendoTag="exchange-rates-excel-export-button"
      />
    </div>

    <ag-grid-angular
      auxGridDynamicHeight
      class="ag-theme-aux mb-8 w-full tabular-nums"
      id="currencyRatesGrid"
      [rowData]="gridData$ | async"
      [gridOptions]="gridOptions"
      [overlayNoRowsTemplate]="(noRowsMessage$ | async)!"
      (gridReady)="onGridReady($event)"
    />
  </div>
}

@if (isLoading$ | async) {
  <div class="spinner m-auto mt-32 h-32 w-32 border-8"></div>
}
